/* eslint-disable no-console */
import {
  Paper,
  Grid
} from "@mui/material";
// import logo from "../../../assets/images/logo.svg";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { httprequest } from "../../../data/api";
import PageLoader from "../../../components/PageLoader";
import useStyles from "../styles";
import Layout from "../../../components/Layout";
import BreadCrumb from "../../../components/BreadCrumb";
import { Icon } from "@iconify/react";
import useWindowSize from "../../../hooks/useWindow";
import Table from "../../../components/Table/Table";
import Badge from "../../../components/Badge";
import { TableSearch } from "../../../components/Table/TableActions";
import PaymentCard from "../../../components/CardCount/PaymentCard";
import { toast } from "react-toastify";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const INVOICE_BY_ID = "/api/v1/invoices/student-invoices";

const MyInvoiceOverview = () => {
  const classes = useStyles();
  const { id } = useParams();
  const [aStudentInvoice, setAStudentInvoice] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [transactionData, setTransactionData] = useState([]);
  const width = useWindowSize();
  const isMobile = width < 600;

  const getInvoiceTransactions = () => {
    httprequest
      .get(`${INVOICE_BY_ID}/${id}/transactions`)
      .then((res) => {
        setTransactionData(res?.data?.data || []);
      }).catch((error) => {
        toast.error(error?.response?.message);
      });
  };

  const getStudentClassInvoice = () => {
    setIsLoading(true);
    httprequest
      .get(`${INVOICE_BY_ID}/${id}`)
      .then((res) => {
        setAStudentInvoice(res?.data?.data);
        setIsLoading(false);
      }).catch(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getStudentClassInvoice();
    getInvoiceTransactions();
  }, []);

  const DetailItem = ({ label, value }) => {
    const renderValue = () => {
    // eslint-disable-next-line no-undefined
      if (value === null || value === undefined) return "--/--";

      if (typeof value === "object" && value !== null) {
        return value.name || value.value || "--/--";
      }

      return value;
    };

    return (
      <div className={classes.detailItem}>
        <label>{label}</label>
        <p>{renderValue()}</p>
      </div>
    );
  };

  const columns = [
    {
      name: "Invoice Name",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Invoice Name</p>}
          {row?.invoice_name || "--/--"}
        </>
      )
    },
    {
      name: "Invoice NO",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Invoice NO</p>}
          {row?.invoice_no || "--/--"}
        </>
      )
    },
    {
      name: "Total Amount",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Total Amount</p>}
          {(row?.amount || 0)?.toLocaleString()}
        </>
      )
    },
    {
      name: "Amount Paid",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Amount Paid</p>}
          {(row?.amount_paid || 0)?.toLocaleString()}
        </>
      )
    },
    {
      name: "Status",
      center: "true",
      cell: (row) => (
        <p style={{ display: "flex", flexDirection: "column", margin: 0, marginBlock: 0 }}>
          {isMobile && <p style={{ margin: 0, fontSize: "12px" }}>Status</p>}
          <Badge status={row?.status} />
        </p>
      )
    }
  ];

  const downloadTransactionReceipt = async () => {
    if (!aStudentInvoice) {
      toast.error("No transaction data available");

      return;
    }

    try {
      const receiptContainer = document.createElement("div");
      receiptContainer.style.padding = "20px";
      receiptContainer.style.backgroundColor = "white";
      receiptContainer.style.position = "absolute";
      receiptContainer.style.left = "-9999px";
      receiptContainer.style.top = "0";

      const originalContainer = document.querySelector(".transaction-details-container");
      const clonedContent = originalContainer.cloneNode(true);

      const logoSection = document.createElement("div");
      logoSection.style.textAlign = "center";
      logoSection.style.marginBottom = "20px";
      logoSection.style.borderBottom = "2px solid #f0f0f0";
      logoSection.style.paddingBottom = "20px";

      const receiptTitle = document.createElement("h1");
      receiptTitle.style.margin = "0 0 15px 0";
      receiptTitle.style.color = "#1976d2";
      receiptTitle.style.fontSize = "24px";
      receiptTitle.style.fontWeight = "bold";

      receiptContainer.appendChild(logoSection);
      receiptContainer.appendChild(clonedContent);

      document.body.appendChild(receiptContainer);

      const canvas = await html2canvas(receiptContainer, {
        scale: 1.5,
        useCORS: true,
        logging: false
      });

      document.body.removeChild(receiptContainer);

      const imgData = canvas.toDataURL("image/png");
      // eslint-disable-next-line new-cap
      const pdf = new jsPDF("p", "mm", "a4");
      const imgWidth = 190;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      pdf.addImage(imgData, "PNG", 10, 10, imgWidth, imgHeight);

      const fileName = `receipt-${aStudentInvoice.invoice_no}.pdf`;
      pdf.save(fileName);
      toast.success("Receipt downloaded successfully!");
    } catch (error) {
      toast.error("Failed to generate receipt");
    }
  };

  return (
    <Layout children={
      <>
        <div className="breadcrumb-container">
          <div>
            <BreadCrumb
              link_one="/payment/overview"
              link_one_name="Payments"
              active={`${aStudentInvoice?.student?.last_name || "--/--"} ${aStudentInvoice?.student?.first_name || "--/--"} Invoice Overview`}
              description="Details of your invoice"
            />
          </div>

        </div>
        <Grid container spacing={isMobile ? 1 : 3}>
          <Grid item lg={3} md={6} sm={6} xs={12}>
            <PaymentCard
              title="Total Amount"
              count={`${aStudentInvoice?.total?.toLocaleString() || 0}`}
              icon={<Icon icon="material-symbols-light:payments-outline" />}
            />
          </Grid>
          <Grid item lg={3} md={6} sm={6} xs={12}>
            <PaymentCard
              title="Amount Paid"
              count={`${aStudentInvoice?.amount_paid?.toLocaleString() || 0}`}
              icon={<Icon icon="fluent:wallet-credit-card-48-filled" width="20" height="20" />}
            />
          </Grid>
          <Grid item lg={3} md={6} sm={6} xs={12}>
            <PaymentCard
              title="Outstanding"
              count={`${aStudentInvoice?.outstanding?.toLocaleString() || 0}`}
              icon={<Icon icon="hugeicons:wallet-remove-01" width="20" height="20" />}
            />
          </Grid>
          <Grid item lg={3} md={6} sm={6} xs={12}>
            <PaymentCard
              title="Overpayment"
              count={`${aStudentInvoice?.overpayment?.toLocaleString() || 0}`}
              icon={<Icon icon="hugeicons:wallet-remove-01" width="20" height="20" />}
            />
          </Grid>
        </Grid>
        <div className="page-content margin-top-30">
          {isLoading ? (
            <PageLoader />
          ) : (
            <>
              <div className="transaction-details-container">
                <Paper elevation={0} className={classes.invoiceContainer}>
                  <header className={classes.invoiceHeader}>
                    <div className={classes.headerLeft}>
                      <h1>Invoice Details</h1>
                      <p>See all information in your Invoice</p>
                    </div>
                    <div className={classes.headerRight}>
                      <span
                        className={classes.statusBadge}
                        style={{
                          backgroundColor:
      aStudentInvoice.status === "paid" ? "#d4edda" :
        aStudentInvoice.status === "partly_paid" ? "#fff3cd" :
          "#f8d7da",
                          color:
      aStudentInvoice.status === "paid" ? "#155724" :
        aStudentInvoice.status === "partly_paid" ? "#856404" :
          "#d9534f"
                        }}
                      >{aStudentInvoice.status || "--/--"}
                      </span>
                      <div className={classes.invoiceNumber}>
                        <small>Invoice Number</small>
                        <span>{aStudentInvoice.invoice_no || "--/--"}</span>
                      </div>
                    </div>
                  </header>

                  <Grid container spacing={3} className={classes.detailsGrid}>
                    <Grid item xs={6} sm={4} md={2}>
                      <DetailItem label="Invoice Name" value={aStudentInvoice?.invoice_name} />
                    </Grid>
                    <Grid item xs={6} sm={4} md={2}>
                      <DetailItem label="Session" value={aStudentInvoice?.session} />
                    </Grid>
                    <Grid item xs={6} sm={4} md={2}>
                      <DetailItem label="Term" value={aStudentInvoice?.term} />
                    </Grid>
                    <Grid item xs={6} sm={4} md={2}>
                      <DetailItem label="Class" value={aStudentInvoice?.class} />
                    </Grid>
                    <Grid item xs={6} sm={4} md={2}>
                      <DetailItem label="Date Created" value={aStudentInvoice?.created_at} />
                    </Grid>
                    <Grid item xs={6} sm={4} md={2}>
                      <DetailItem label="Date Due" value={aStudentInvoice?.due_date} />
                    </Grid>
                  </Grid>

                  <section className={classes.invoiceParties}>
                    <div className={classes.clientInfo}>
                      <p>
                        <strong>
                          {aStudentInvoice?.student ?
                            `${aStudentInvoice?.student?.first_name || ""} ${aStudentInvoice?.student?.last_name || ""}`.trim() || "--/--"
                            : "--/--"
                          }
                        </strong>
                      </p>
                      <p>{aStudentInvoice?.student?.address || "--/--"}</p>
                    </div>
                    <div className={classes.companyInfo}>
                      <p>{aStudentInvoice?.school?.phone || "--/--"}</p>
                      <p>{aStudentInvoice?.school?.email || "--/--"}</p>
                      <p>{aStudentInvoice?.school?.address || "--/--"}</p>
                    </div>
                  </section>
                  <section className={classes.invoiceTableSection}>
                    <table className={classes.invoiceTable}>
                      <thead>
                        <tr>
                          <th>Service Description</th>
                          <th>Qty</th>
                          <th>Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        {aStudentInvoice?.fee_items && aStudentInvoice?.fee_items.length > 0 ? (
                          aStudentInvoice?.fee_items?.map((item) => (
                            <tr key={item.id}>
                              <td>{item.item || "--/--"}</td>
                              <td>1</td>
                              <td>{(item.amount || 0)?.toLocaleString()}</td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="3" style={{ textAlign: "center" }}>No items found</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </section>

                  <section className={classes.summaryContainer}>
                    <div className={classes.summaryWrapper}>
                      <div className={classes.summaryRow}>
                        <span>SUB TOTAL</span>
                        <span>{(aStudentInvoice?.total || 0)?.toLocaleString()}</span>
                      </div>
                      <div className={classes.summaryRow}>
                        <span>TAX</span>
                        <span>0</span>
                      </div>
                      <div className={classes.summaryRow}>
                        <span>DISCOUNT</span>
                        <span>{(aStudentInvoice?.discount_value || 0)?.toLocaleString()}</span>
                      </div>
                      <div className={`${classes.summaryRow} ${classes.grandTotal}`}>
                        <span>AMOUNT PAYABLE</span>
                        <span>{(aStudentInvoice?.amount_payable || 0)?.toLocaleString()}</span>
                      </div>
                    </div>
                  </section>

                  <footer className={classes.invoiceFooter}>
                    <button className={classes.printButton} onClick={downloadTransactionReceipt}>
                      <Icon icon="mdi-light:printer" width="24" height="24" />
                      <span>Print Invoice</span>
                    </button>
                  </footer>
                </Paper>
              </div>
              <div className="white_bg">
                <h3 style={{ textAlign: "left" }}>Transaction History</h3>
                <Table
                  data={transactionData}
                  columns={columns}
                  subHeader={true}
                  pagination
                  subHeaderComponent={
                    <div className="action_div">
                      <TableSearch
                        placeholder="Search here..."
                      />
                    </div>}
                />
              </div>
            </>
          )}
        </div>

      </>
    }
    />
  );
};

export default MyInvoiceOverview;
